export default [
  {
    path: '/voucher/generate',
    name: 'Voucher.Generate.List',
    component: () =>
      import(
        '@/views/Voucher/Generate/List.vue'
      ),
    meta: {
      title: 'List Generate Voucher',
      icon: 'fas fa-shopping-cart fa-2x'
    },
  },
  {
    path: '/voucher/generate/add',
    name: 'Voucher.Generate.Add',
    component: () =>
      import(
        '@/views/Voucher/Generate/Form.vue'
      ),
    meta: {
      title: 'Add Generate Voucher',
      icon: 'fas fa-shopping-cart fa-2x'
    },
  },
  {
    path: '/voucher/generate/:id/edit',
    name: 'Voucher.Generate.Edit',
    component: () =>
      import(
        '@/views/Voucher/Generate/Form.vue'
      ),
    meta: {
      title: 'Edit Generate Voucher',
      icon: 'fas fa-shopping-cart fa-2x'
    },
  },
]
